import { PaymentEstimateObject } from '@liscio/api';

export type Quarter = 'q1' | 'q2' | 'q3' | 'q4';

interface QuarterConfig {
  key: Quarter;
  title: string;
  amountKey: keyof Pick<
    PaymentEstimateObject,
    'q1_payment_estimate' | 'q2_payment_estimate' | 'q3_payment_estimate' | 'q4_payment_estimate'
  >;
  dateKey: keyof Pick<
    PaymentEstimateObject,
    'q1_due_date' | 'q2_due_date' | 'q3_due_date' | 'q4_due_date'
  >;
}

export const QUARTERS: QuarterConfig[] = [
  { key: 'q1', title: 'Q1', amountKey: 'q1_payment_estimate', dateKey: 'q1_due_date' },
  { key: 'q2', title: 'Q2', amountKey: 'q2_payment_estimate', dateKey: 'q2_due_date' },
  { key: 'q3', title: 'Q3', amountKey: 'q3_payment_estimate', dateKey: 'q3_due_date' },
  { key: 'q4', title: 'Q4', amountKey: 'q4_payment_estimate', dateKey: 'q4_due_date' },
];
